import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';

export const ServiceHeader = ({ handleWhatsAppClick }) => {
const navigate = useNavigate();
return (
<header className="fixed top-0 w-full z-50 bg-black/95 backdrop-blur-md border-b border-red-900/40">
        <nav className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Button data-testid="service-back-home-button" onClick={() => navigate('/')} variant="ghost" className="text-white hover:text-red-500">
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour Accueil
            </Button>
            <Button data-testid="service-header-whatsapp-button" onClick={handleWhatsAppClick} className="bg-gradient-to-r from-green-500 to-green-600">
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>
        </nav>
      </header>
);
};
